/* eslint-disable ember/no-controller-access-in-routes, ember/no-runloop, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { next } from '@ember/runloop';
import TransactionType from '@linc-technologies/linced-common/enums/transaction-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class LedgerItemSummaryRoute extends Route {
  queryParams = {
    from: {
      refreshModel: true,
    },
    to: {
      refreshModel: true,
    },
    transactionType: {
      refreshModel: true,
    },
    cancelled: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  model(params) {
    let baseFilters = {
      dateFrom: params.from,
      dateTo: params.to,
      include: 'lineItems,ledgerItems,ledgers,accounts',
    };
    if (params.cancelled) {
      baseFilters.isCancelled = true;
    } else {
      baseFilters.isNotCancelled = true;
    }
    let transactionFilters = {
      type: params.transactionType,
    };
    Object.assign(transactionFilters, baseFilters);
    let requests = {
      transactions: this.store.query('finance/transaction', transactionFilters),
    };
    // Retrieve Apportionment records too if the user selected Payment as the type.
    if (parseInt(params.transactionType, 10) === TransactionType.PAYMENT) {
      let apportionmentFilters = {
        type: TransactionType.APPORTIONMENT,
      };
      Object.assign(apportionmentFilters, baseFilters);
      requests.apportionments = this.store.query(
        'finance/transaction',
        apportionmentFilters,
      );
    }
    return hash(requests);
  }

  activate() {
    super.activate(...arguments);
    next(this, function () {
      this.controllerFor('application').set('isWideList', true);
    });
  }

  deactivate() {
    super.deactivate(...arguments);
    next(this, function () {
      this.controllerFor('application').set('isWideList', false);
    });
  }
}
